// Rodapé de linhagem — de onde vem o número e se ele está em dia.
//
// Exigência do §5.1 (e do PRD §8): todo indicador relevante exibe origem,
// última atualização e condição do dado. Existia só no Painel do Gestor; desde
// 18/09 é este componente, usado também na Visão Financeiro — uma cópia por tela
// é como as duas acabam dizendo coisas diferentes.

import { useQuery } from "@tanstack/react-query";
import { buscarLinhagem } from "../lib/api.ts";

const ROTULO_FONTE: Record<string, string> = { conta_azul: "Conta Azul" };

export function RodapeLinhagem() {
  const linhagem = useQuery({ queryKey: ["linhagem"], queryFn: buscarLinhagem });
  if (!linhagem.data?.fontes.length) return null;

  return (
    <footer className="mt-6 flex flex-wrap gap-x-6 gap-y-1 border-t border-linha pt-4 text-[12px] text-tinta-fraca">
      {linhagem.data.fontes.map((f) => (
        <span key={f.fonte}>
          <strong className="font-semibold text-tinta-media">{ROTULO_FONTE[f.fonte] ?? f.fonte}</strong>{" "}
          <span className={f.status === "ok" ? "" : "font-semibold text-atencao-tinta"}>
            {f.status === "ok" ? "atualizado" : f.status === "atrasado" ? "atrasado" : "com falha"}
          </span>
          {f.ultima_sincronizacao &&
            ` · última leitura ${new Date(f.ultima_sincronizacao).toLocaleString("pt-BR", {
              dateStyle: "short",
              timeStyle: "short",
              timeZone: "America/Sao_Paulo",
            })}`}
          {f.detalhe && f.status !== "ok" && ` · ${f.detalhe}`}
        </span>
      ))}
    </footer>
  );
}
